import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { broadCastNotification } from "../../app/Slices";

import { useAlert, useConfirmationDialog } from "@/";
import {
  Button,
  AddressInputField,
  InputField,
  FileUploadInput,
} from "@/components";
const NotificationForm = ({ setNotificationAlertOpen = false, data = {} }) => {
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();

  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    id: data?.id || null,
    description: data?.subtitle || "",
    title: data?.title || "Indian Courier Company",
    file1: data?.imageUrl || "https://dummy.com",
    file2: data?.ActionUrl || "https://dummy.com",
    // Set file as null initially
  });
  const handleChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const [error, setError] = useState("");
  const handleFileChange = (key, file) => {
    console.log("Selected File:", file); // Debugging

    if (file && file instanceof File) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        [key]: file,
      }));
      setError("");
    } else {
      console.error("Invalid file selected");
      setError("Please select a valid file.");
    }
  };
  const handleAddNotification = async () => {
    console.log("Filters before submitting:", filters);

    if (!filters.description) {
      alert("Please fill all fields before submitting.");
      return;
    }
    await confirm("Are you sure you want to add this Notification?");
    try {
      const data = {
        isBroadCast: true, // Fix boolean casing
        content: {
          title: filters.title,
          message: filters.description,
          imageUrl: filters.file1,
          actionImageUrl: filters.file2,
        },
      };

      console.log("Notification Data:", data);

      // Dispatch and get the action result
      const action = await dispatch(broadCastNotification(data));

      if (broadCastNotification.fulfilled.match(action)) {
        await alert("Notification added successfully!");
        setNotificationAlertOpen(false);
        setFilters({
          id: "",
          description: "",
          title: "",
          file1: null,
          file2: null,
        });
      } else {
        await alert(action.payload || "Failed to add Notification.");
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
      await alert(error.message || "An unexpected error occurred.");
    }
  };

  return (
    <div className="flex flex-col gap-1">
      {/* <InputField
        label="Title"
        placeholder="Enter the title of Notification"
        value={filters.title}
        onChange={(value) => handleChange("title", value)}
      /> */}
      <AddressInputField
        label="Broadcasting Message"
        placeholder="Enter the description of Notification"
        value={filters.description}
        onChange={(value) => handleChange("description", value)}
      />
      {/* <FileUploadInput
        id="Notification-image"
        label="Notification image (if any)"
        disabled={false}
        error={error}
        className="max-w-full p-0"
        onChange={(file) => handleFileChange("file1", file)} // Pass selected file
      /> */}
      {/* <FileUploadInput
        id="Action-image"
        label="Action Image (if any)"
        disabled={false}
        error={error}
        className="max-w-full p-0"
        onChange={(file) => handleFileChange("file2", file)} // Pass selected file
      /> */}
      <div className="w-full">
        <Button
          className="h-12 w-full mt-4"
          size="md"
          onClick={handleAddNotification}
        >
          {"Add Notification"}
        </Button>
      </div>
      <AlertDialog />
      <ConfirmationModal />
    </div>
  );
};

export default NotificationForm;
